<template>
    <div class="mvt-cardmortgage">
        <a target="_blank" :href="data.cpc + utmSource" rel="nofollow" >
            <div>
                <div class="text-bold">
                    {{$filters.formatPrice(data.estpayment)}}/mo - APR {{data.apr}}%
                </div>
                <div class="f6">
                    {{$filters.formatPrice(data.fees)}} initial fee - {{data.rate}}% at {{data.discpoints}} pts
                </div>
            </div>
            <div class="mls-logo">
                <img :src="data.logo" loading="lazy"/>
                <div class="f6" v-if="data.NMLS">
                    NMLSID:{{data.NMLS}}
                </div>
                <div class="f6" v-else-if="data.LICENSE">
                    Lender License: {{data.LICENSE}}
                </div>
            </div>
            <div class="btn primary small" v-if="!data.isPersonal" @click="applyBtn">Next</div>
        </a>
        <div class="f8 text-gray" v-if="openMortgage && data.advertiserPLabel">{{ data.advertiserPLabel }}</div>
    </div>

</template>

<script src="./mvt-cardmortgage-new.js"></script>
<style lang="scss">
@use "./mvt-cardmortgage-new.scss" as *;
</style>
